import { parseISO } from "date-fns";
import { Location } from "history";
import { IDashboardMapSettings } from "../../components/dashboard";

const REDIRECT_ON_LOGIN = "redirect_on_login";
const PROLOGS_LAST_ACTIVITY = "prologs_last_activity";
const DASHBOARD_MAP_SETTINGS = "dashboard_map_settings";

export const localStorageService = {
  setLastActivity: () => {
    localStorage.setItem(PROLOGS_LAST_ACTIVITY, new Date().toISOString());
  },

  getLastActivity: () => {
    const fromLs = localStorage.getItem(PROLOGS_LAST_ACTIVITY);
    if (!fromLs) {
      // If there is nothing in local storage, assume the user is active.
      return new Date();
    }

    try {
      return parseISO(fromLs);
    } catch {
      console.error("Invalid value for last activity in local storage", fromLs);
      return new Date();
    }
  },

  setRedirect: (location: Location<unknown>) => {
    if (location.pathname === "/logout") {
      return;
    }

    localStorage.setItem(REDIRECT_ON_LOGIN, JSON.stringify(location));
  },

  setRedirectToPath: (redirect: string) => {
    if (redirect === "/logout") {
      return;
    }

    const location: Location<unknown> = {
      pathname: redirect,
      search: "",
      state: "",
      hash: "",
    };
    localStorage.setItem(REDIRECT_ON_LOGIN, JSON.stringify(location));
  },

  clearRedirect: () => {
    const location: Location<unknown> = {
      pathname: "/",
      search: "",
      state: "",
      hash: "",
    };
    localStorage.setItem(REDIRECT_ON_LOGIN, JSON.stringify(location));
  },

  getRedirect: (keep: boolean = false) => {
    const jsonifiedLocation: string | null = localStorage.getItem(
      REDIRECT_ON_LOGIN
    );

    if (!jsonifiedLocation) {
      return undefined;
    }

    const location: Location<unknown> = JSON.parse(jsonifiedLocation);
    if (!keep) {
      localStorage.removeItem(REDIRECT_ON_LOGIN);
    }

    if (location.pathname === "/logout") {
      return undefined;
    }

    return location;
  },

  getDashboardMapSettings: () => {
    const jsonifiedSettings: string | null = localStorage.getItem(
      DASHBOARD_MAP_SETTINGS
    );

    if (!jsonifiedSettings) {
      return undefined;
    }

    const settings: IDashboardMapSettings | undefined = JSON.parse(
      jsonifiedSettings
    );
    return settings;
  },

  setDashboardMapSettings: (settings: IDashboardMapSettings) => {
    localStorage.setItem(DASHBOARD_MAP_SETTINGS, JSON.stringify(settings));
  },
};
